import $ from 'jquery';
const REVIEW_WRAPPER = '.Product-badge_reviews_wrapper';
const REVIEW_SELECTOR = '[data-oke-star-rating] .oke-sr-stars';
export const init = async function() {
    $(REVIEW_WRAPPER).each(function() {
        if ($(this).find(REVIEW_SELECTOR).length > 0) {
            $(this).addClass('has-reviews');
        }
    });
    // Initialize Okendo widgets
    if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
        window.okeWidgetApi.initAllWidgets();
    }
};
